export default __webpack_public_path__ + "static/media/logo_tech.42804ddb.png";